export default {
    title: "請選擇",
    form1: "顏色分類：",
    form2: "規格分類：",
    form3: "訂購數量：",
    errmsg1: "請選擇顏色屬性！",
    errmsg2: "請選擇規格屬性！",
    errmsg3: "您還沒有權限購買此商品，請聯繫管理員！",
}